import { SearchLspBrandsQuery } from 'src/apps/brand-connect/api/generated/graphql';

import { BrandRow } from './types';

type BrandQueryData = SearchLspBrandsQuery['searchLspBrands']['results'];

export const transformBrandQueryDataToRowData = (
  data: BrandQueryData | undefined,
): BrandRow[] =>
  (data || []).map((result) => ({
    id: result.brand.id,
    name: result.brand.name,
    connectionStatus: result.settings?.dataSharingEnabled || false,
    grossMerchandiseValue: result.insights.totalSales,
    imageUrl: result.brand.imageUrl || undefined,
  }));
